import { memo } from 'react';
import { Clock } from 'lucide-react';

/**
 * Timer Component
 * Displays countdown timer for Time Attack mode
 * Memoized to prevent unnecessary re-renders
 */
const Timer = memo(function Timer({ timeRemaining }) {
  if (timeRemaining === null || timeRemaining === undefined) {
    return null;
  }

  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;
  const formattedTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;

  // Color changes based on time remaining
  const getColor = () => {
    if (timeRemaining <= 10) return 'text-red-600';
    if (timeRemaining <= 30) return 'text-orange-600';
    return 'text-green-600';
  };

  const getBackgroundColor = () => {
    if (timeRemaining <= 10) return 'bg-red-100';
    if (timeRemaining <= 30) return 'bg-orange-100';
    return 'bg-green-100';
  };

  return (
    <div
      className={`inline-flex items-center gap-2 ${getBackgroundColor()} rounded-2xl px-6 py-3 ${
        timeRemaining <= 10 ? 'animate-pulse' : ''
      }`}
    >
      <Clock className={getColor()} size={28} />
      <span className={`text-3xl font-bold ${getColor()}`}>
        {formattedTime}
      </span>
    </div>
  );
});

export default Timer;
